export
default {
        common:
        {
            langEn: 'English',     
            langZh: '简体中文',       
            langFt: '繁體中文',      
            langMl: 'Bahasa Melayu', 
            langYn: 'Tiếng Việt',   
            langJa: '日本語',         
            langKr: '한국어',       
            langFa: 'Français',    
            langTr: 'Türkçe',     
            langYin: 'Bahasa Indonesia', 
            langEs: 'Español'   
        },

        home: {
            h1: "MetaMask 암호화폐",
            h1B: "MetaMask 암호화폐 은행",
            h1C: "DeFi 지갑 암호화폐",
            h1D: "Coinbase 암호화폐 은행",
            h1E: "MetaMask 저축 은행",
            h1F: "Betterment",
            h2: "친구 초대",
            h3: "출금 계좌 연결",
            h4: "저축 참여",
            h4B: "암호화폐 입금",
            h4C: "디지털 통화 충전",
            h5: "추천 투자",
            h5B: "초 단위 계약 거래",
            h5c: "입금",
            h6: "사용자 풀",
            h7: "USDT 계좌",
            h8: "총 생산량",
            h9: "유효 노드",
            h10: "참가자",
            h11: "수익",
            h12: "수익 기록",
            h13: "주소",
            h14: "번호",
            h15: "자주 묻는 질문",
            h16: "어떻게 참여합니까?",
            h17: "친애하는 사용자님, USDT 지갑 저축에 참여하려면 플랫폼 사용자 규칙을 준수하고, 플랫폼의 결정을 엄격히 따르며, 리스크 부서의 감독을 받아야 합니다. 자동으로 입금 권한이 부여됩니다. 참여를 환영합니다. 감사합니다.",
            h17B: "친애하는 사용자님, USDT 지갑 저축에 참여하려면 플랫폼 사용자 규칙을 준수하고, 플랫폼의 결정을 엄격히 따르며, 리스크 부서의 감독을 받아야 합니다. 자동으로 입금 권한이 부여됩니다. 참여를 환영합니다. 감사합니다.",
            h18: "출금은 어떻게 합니까?",
            h19: "매일 발생하는 수익은 자동으로 계좌 잔액에 입금되며, USDT 출금이 성공하면 자동으로 USDT 지갑 계좌에 추가됩니다. 엔화로 출금하려면 고객센터에 문의하세요. 참여와 지원에 감사드립니다.",
            h19B: "매일 발생하는 수익은 자동으로 계좌 잔액에 입금되며, USDT 출금이 성공하면 자동으로 USDT 지갑 계좌에 추가됩니다. 다른 출금 방법을 사용하려면 온라인 고객센터에 문의하세요.",
            h20: "수익은 어떻게 계산됩니까?",
            h21B: "주기 형식으로 구매하며, VIP 등급에 따라 수익이 다릅니다\nVIP1  100u~5000u, 이율: 1.8%\nVIP2  5000u~20000u, 이율: 2.6%\nVIP3  20000u~50000u, 이율: 3.5%\nVIP4  50000u~80000u, 이율: 4.7%\nVIP5  80000u~120000u, 이율: 5.3%\nVIP6  120000u~160000u, 이율: 6.2%\nVIP7  160000u~200000u, 이율: 7.3%\nVIP8  200000u 이상, 이율: 8%\n\n",
            h21: "성공적으로 참여하면 저축 계약이 수익 계산을 시작합니다.",
            h22: "저축 수익은 어디서 오나요?",
            h23: "사용자가 저축에 참여하면 저축 계약이 발효됩니다. 매일 00:00, 12:00 두 번 이자가 정산됩니다. 저축 계약 발효 후 자금은 관리 모드에 들어가며, 플랫폼이 자금 안전을 책임집니다. 계좌 자금 안전을 위해 플랫폼 규칙을 준수하시고, 문제가 있으면 온라인 고객센터에 문의하세요.",
            h23B: "사용자가 저축에 참여하면 저축 계약이 발효됩니다. 매일 00:00, 12:00 두 번 이자가 정산됩니다. 저축 계약 발효 후 자금은 관리 모드에 들어가며, 플랫폼이 자금 안전을 책임집니다. 계좌 자금 안전을 위해 플랫폼 규칙을 준수하시고, 문제가 있으면 온라인 고객센터에 문의하세요.",
            h24: "보너스는 얼마입니까?",
            h25: "당신은 저의 플랫폼을 친구와 공유할 수 있습니다. 친구가 참여하면 첫 입금 금액의 20% 추천 보상을 받고, 그 수익의 10%를 영구적으로 받을 수 있습니다. 공개 링크는 홈페이지 오른쪽 상단에 있습니다.",
            h25B: "당신은 이 플랫폼을 친구와 공유할 수 있습니다. 친구가 참여하면 첫 입금 금액의 20% 추천 보상을 받고, 그 수익의 10%를 영구적으로 받을 수 있습니다. 공유 링크는 홈페이지 오른쪽 상단에 있습니다.",
            h26: "사용 가능 잔액",
            h27: "입금 금액",
        
            h88: "플랫폼 배경",
            h89: "Betterment\n설립 연도: 2008년\n본사: 미국 뉴욕\n포지셔닝: 로보어드바이저(Robo-Advisor) 및 핀테크(FinTech), 자동 투자 포트폴리오 및 현금 관리 제공\n감독 기관: 금융거래위원회(SEC) 감독, FINRA 회원\n고객 규모: 관리 자산 400억 달러 이상\n고객층: 개인 및 기업 80만 명 이상",
            h90: "플랫폼 장점",
            h91: "✔️ 미국 최초 Robo-Advisor, 경험 풍부\n✔️ 투자 포트폴리오 현대 자산배분 이론(MPT)에 기반, 위험 분산\n✔️ 세금 최적화 기능 제공\n✔️ 고이율 현금 계좌, 유동성 높음\n✔️ 전 과정 디지털화, 간단한 인터페이스",
            h92: "적합한 사용자",
            h93: "★ 장기 안정적 투자 희망, 잦은 조작 원치 않는 사용자\n★ 자동화 자산 관리로 시간과 노력 절약을 원하는 젊은 투자자\n★ 투자 + 고금리 저축 + 퇴직 계좌 보유자\n★ 낮은 비용으로 금융시장 참여를 원하는 일반 투자자",
        
            h28: "오늘 수익",
            h29: "총 수익",
            h30: "출금",
            h31: "기록",
            h32: "사용 가능 잔액",
            h33: "출금 금액",
            h34: "출금 금액을 입력하세요",
            h35: "전체",
            h36: "출금",
            h37: "자주 묻는 질문",
            h38: "보안 감사 보고서 있음",
            h39: "파트너",
            h40: "우리의 비즈니스 파트너",
            h41: "은행 카드 번호 표시",
            h42: "이전 페이지",
            h43: "다음 페이지",
            h44: "이미 첫 페이지입니다",
            h45: "출금 금액을 입력하세요",
            h46: "잔액 부족",
            h47: "이미 마지막 페이지입니다",
            h48: "수입",
            h49: "지출",
            h50: "조작이 너무 빈번합니다. 잠시 후 다시 시도하세요.",
            h51: "감사 보고서",
            h52: "코인 예치 수익",
            h521: "예금 수익",
            h53: "주문 거래",
            h54: "가입 보상",
            h55: "초대 보상",
            h56: "출금",
            h57: "충전",
            h58: "예금",
            h59: "인출",
            h591: "입금 성공",
            h592: "입금 실패",
            h593: "잔액 부족",
            h60: "암호화폐 송금으로 USDT 선물",
            h61: "MetaMask 은행을 지속적으로 지원해주셔서 감사합니다. 저축을 더 편리하게 하기 위해 암호화폐(USDT ETH BTC)로 송금 저축 시 보너스를 받을 수 있습니다. 1000 USDT 이상 저축 시 30 USDT, 5000 USDT 이상 200 USDT, 10000 USDT 이상 매회 금액의 5% 보너스 지급. (암호화폐 지갑 출금도 동일 혜택 적용)",
            h61B: "Coinbase 은행을 지속적으로 지원해주셔서 감사합니다. 암호화폐(USDT ETH BTC)로 송금 저축 시 보너스를 받을 수 있습니다. 1000 USDT 이상 저축 시 30 USDT, 5000 USDT 이상 200 USDT, 10000 USDT 이상 매회 금액의 5% 보너스 지급.",
            h61C: "MetaMask 은행을 지속적으로 지원해주셔서 감사합니다. 암호화폐(USDT ETH BTC)로 송금 저축 시 보너스를 받을 수 있습니다. 1000 USDT 이상 저축 시 30 USDT, 5000 USDT 이상 200 USDT, 10000 USDT 이상 매회 금액의 5% 보너스 지급.",
            h61D: "Betterment를 지속적으로 지원해주셔서 감사합니다. 암호화폐(USDT ETH BTC)로 송금 저축 시 보너스를 받을 수 있습니다. 1000 USDT 이상 저축 시 30 USDT, 5000 USDT 이상 200 USDT, 10000 USDT 이상 매회 금액의 5% 보너스 지급.",
            h62: "출금 금액은 {amount}, 수수료는 {fee}%입니다!",
            h63: "확인",
            h99: "오픈 예정",
        },
        bankcard: {
            b1: "은행 계좌",
            b2: "금융 기관명",
            b3: "금융 기관명을 입력하세요",
            b4: "지점명",
            b5: "지점명을 입력하세요",
            b6: "지점 번호",
            b7: "지점 번호를 입력하세요",
            b8: "계좌 번호(일반)",
            b9: "계좌 번호를 입력하세요",
            b10: "가명",
            b11: "사용자명을 입력하세요",
            b12: "계좌 명의",
            b13: "계좌 명의자를 입력하세요",
            b14: "연결",
            b15: "가상 화폐 주소",
            b16: "가상 화폐 주소를 입력하세요",
        },
        usdt: {
            u1: "내 주문",
            u2: "입금",
            u3: "계약 기간 선택:",
            u4: "구매 가격:",
            u5: "입금 금액을 입력하세요",
            u6: "구매 증가",
            u7: "구매 감소",
            u8: "작업 성공",
            u9: "최소한 조금"
        },
        order: {
            o0: "내 주문",
            o1: "주문 번호",
            o2: "주문 유형",
            o3: "구매 금액",
            o4: "판매 금액",
            o5: "지불 금액",
            o6: "계약 기간",
            o7: "주문 상태",
            o8: "결제 상태",
            o9: "결제 시간",
            o10: "주문 시간",
            o11: "구매 증가",
            o12: "구매 감소",
            o13: "판매 완료",
            o14: "수익",
            o15: "손실",
            o16: "지불 완료",
            o17: "손익분기점"
        },
        recharge: {
            r1: "충전 금액",
            r2: "충전 금액 수",
            r3: "충전 유형",
            r4: "선택하세요",
            r5: "충전 주소",
            r6: "송금 거래 번호",
            r7: "송금 완료",
            r8: "심사 중",
            r9: "입력이 올바르지 않습니다",
            r10: "결제 방법을 선택하세요",
            r11: "최소 충전 금액은",
            r12: "최대 충전 금액은",
            r13: "금액을 입력하세요",
            r14: "결제 스크린샷 업로드",
            r15: "결제 스크린샷을 업로드하세요",
            r16: "제출 성공",
            r17: "취소",
            r18: "확인",
        },
        rechargeDetails: {
            r1: "충전 기록",
            r2: "충전 금액",
            r3: "심사 중",
            r4: "충전 성공",
            r5: "충전 실패"
        },
		cert: {
		    c1: "실명 인증",
		    c2: "실제 이름",
		    c21: "실제 이름을 입력하세요",
		    c3: "인증 유형",
		    c31: "신분증",
		    c32: "여권",
		    c33: "운전면허증",
		    c10: "인증 유형을 입력하세요",
		    c4: "증명서 앞면",
		    c41: "증명서 앞면을 업로드하세요",
		    c5: "증명서 뒷면",
		    c51: "증명서 뒷면을 업로드하세요",
		    c6: "제출",
		    c7: "성공적으로 제출되었습니다. 검토 중입니다...",
		    c8: "인증 완료",
		    c9: "실명 인증 실패. 다시 업로드하세요",
		    c11: "검토 중",
		    "传入字段不完整": "입력된 필드가 불완전합니다",
		    "已认证过": "이미 인증되었습니다",
		    "审核中": "검토 중"
		}
		 }